



























































































































import Vue from "vue";
import router from "@/router/router";
import { ActionTypes } from "@/store/modules/Auth/actions-types";
import { store } from "../../../store/store";

// components
import Alert from "@/components/Popup/Alert/Alert.vue";
import SuccessModal from "@/components/Popup/Modal/SuccessModal.vue";

declare interface ResetPasswordBaseData {
  temporary_token: string;
  firstPassword: string;
  secondPassword: string;
  showFirstPassword: boolean;
  showSecondPassword: boolean;
  error: boolean;
  errorTiming: number;
  disabledConnectionButton: boolean;
  loading: boolean;
  displayModal: boolean;
  modal_message: string;
  redirectionTiming: 3;
  rules: Array<unknown>;
}

export default Vue.extend({
  name: "ResetPassword",
  components: { Alert, SuccessModal },
  data: (): ResetPasswordBaseData => {
    return {
      temporary_token: String(new URLSearchParams(window.location.search).get("temporary_token")),
      firstPassword: "",
      secondPassword: "",
      showFirstPassword: false,
      showSecondPassword: false,
      error: false,
      errorTiming: 0,
      disabledConnectionButton: false,
      loading: false,
      displayModal: false,
      redirectionTiming: 3,
      modal_message: "Votre mot de passe à bien été pris en compte, vous allez être redirigé dans 3",
      rules: [
        (value: string): boolean | string => value.length > 0 || `Le champ mot de passe est obligatoire`,
        (value: string): boolean | string => value.length > 0 || `Le champ mot de passe est obligatoire`
      ]
    };
  },
  methods: {
    async reset_password(): Promise<void> {
      if ((this.$refs.form as Vue & { validate: () => boolean }).validate()) {
        this.loading = true;
        const { firstPassword, secondPassword, temporary_token } = this;
        if (firstPassword === secondPassword) {
          const status = await store.dispatch(ActionTypes.RESET_PASSWORD, {
            temporary_token: temporary_token,
            password: firstPassword
          });
          if (status === 200) this.displayModal = true;
          else this.error = true;
        } else this.error = true;
        this.loading = false;
      }
    },
    checkIfButtonShouldBeDisabled(): void {
      if (this.firstPassword.length == 0 && this.secondPassword.length == 0) this.disabledConnectionButton = true;
      else this.disabledConnectionButton = false;
    },
    stopDisplayError(): void {
      this.error = false;
    }
  },
  watch: {
    email(): void {
      this.checkIfButtonShouldBeDisabled();
    },
    password(): void {
      this.checkIfButtonShouldBeDisabled();
    },
    error(): void {
      if (this.error) {
        this.errorTiming = window.setTimeout(() => {
          this.error = false;
        }, 3000);
      } else window.clearTimeout(this.errorTiming);
    },
    displayModal(): void {
      const interval = window.setInterval(() => {
        this.redirectionTiming -= 1;
        if (this.redirectionTiming == 0) {
          clearInterval(interval);
          router.push({ path: "/" });
        }
      }, 1000);
    },
    redirectionTiming(): void {
      this.modal_message = `${this.modal_message.substr(
        0,
        this.modal_message.length - 1
      )}${this.redirectionTiming.toString()}`;
    }
  }
});
